/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetParams,
  GrpoRecipeValues,
  HTTPValidationError,
  HeldOutEvalStartResponse,
  HeldOutTestsResponse,
  HeldOutTestsUpdate,
  ModelResponse,
  TrainingCloneTokenResponse,
  TrainingDeploymentRecord,
  TrainingGrpoOptionsResponse,
  TrainingLaunchRequest,
  TrainingLaunchView,
  TrainingRolloutCredentialsRequest,
  TrainingRolloutCredentialsResponse,
  TrainingRunDocument,
  TrainingRunsResponse,
  TrainingScheduleResponse,
  TrainingScheduleUpdate,
  TrainingSetOption,
  TrainingSetOptionsResponse,
  TrainingSetRegisterRequest,
  TrainingSetRegistration,
  TrainingSetStagingUpload,
  TrainingSetStagingUploadRequest,
  TrainingSetUploadRequest,
  TrainingStatusRequest,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listTrainingRunsApiTrainingRunsGetResponse200 = {
  data: TrainingRunsResponse;
  status: 200;
};

export type listTrainingRunsApiTrainingRunsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTrainingRunsApiTrainingRunsGetResponseSuccess =
  listTrainingRunsApiTrainingRunsGetResponse200 & {
    headers: Headers;
  };
export type listTrainingRunsApiTrainingRunsGetResponseError =
  listTrainingRunsApiTrainingRunsGetResponse422 & {
    headers: Headers;
  };

export type listTrainingRunsApiTrainingRunsGetResponse =
  | listTrainingRunsApiTrainingRunsGetResponseSuccess
  | listTrainingRunsApiTrainingRunsGetResponseError;

export const getListTrainingRunsApiTrainingRunsGetUrl = () => {
  return `/api/training-runs`;
};

/**
 * Every training run exported for the caller's team, newest first.
 *
 * A team without gateway credentials has no slug and therefore no bucket
 * prefix — that's an empty list, not an error, so the page renders for
 * brand-new teams.
 * @summary List Training Runs
 */
export const listTrainingRunsApiTrainingRunsGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTrainingRunsApiTrainingRunsGetResponse> => {
  return orvalFetch<listTrainingRunsApiTrainingRunsGetResponse>(
    getListTrainingRunsApiTrainingRunsGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTrainingRunsApiTrainingRunsGetQueryKey = () => {
  return [`/api/training-runs`] as const;
};

export const getListTrainingRunsApiTrainingRunsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTrainingRunsApiTrainingRunsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>
  > = ({ signal }) =>
    listTrainingRunsApiTrainingRunsGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTrainingRunsApiTrainingRunsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>
>;
export type ListTrainingRunsApiTrainingRunsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTrainingRunsApiTrainingRunsGet<
  TData = Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
          TError,
          Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTrainingRunsApiTrainingRunsGet<
  TData = Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
          TError,
          Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTrainingRunsApiTrainingRunsGet<
  TData = Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Training Runs
 */

export function useListTrainingRunsApiTrainingRunsGet<
  TData = Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTrainingRunsApiTrainingRunsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListTrainingRunsApiTrainingRunsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponse200 =
  {
    data: TrainingRolloutCredentialsResponse;
    status: 200;
  };

export type getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponseSuccess =
  getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponse200 & {
    headers: Headers;
  };
export type getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponseError =
  getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponse422 & {
    headers: Headers;
  };

export type getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponse =

    | getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponseSuccess
    | getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponseError;

export const getGetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetUrl =
  () => {
    return `/api/training-runs/rollout-credentials`;
  };

/**
 * The names of the team's stored rollout values, never the values.
 * @summary Get Training Rollout Credentials
 */
export const getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet =
  async (
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponse> => {
    return orvalFetch<getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetResponse>(
      getGetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetUrl(),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getGetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetQueryKey =
  () => {
    return [`/api/training-runs/rollout-credentials`] as const;
  };

export const getGetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
        >
      >
    > = ({ signal }) =>
      getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet({
        signal,
        ...requestOptions,
      });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
      >
    >
  >;
export type GetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet<
  TData = Awaited<
    ReturnType<
      typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet<
  TData = Awaited<
    ReturnType<
      typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet<
  TData = Awaited<
    ReturnType<
      typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Training Rollout Credentials
 */

export function useGetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet<
  TData = Awaited<
    ReturnType<
      typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponse200 =
  {
    data: TrainingRolloutCredentialsResponse;
    status: 200;
  };

export type setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponseSuccess =
  setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponse200 & {
    headers: Headers;
  };
export type setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponseError =
  setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponse422 & {
    headers: Headers;
  };

export type setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponse =

    | setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponseSuccess
    | setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponseError;

export const getSetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutUrl =
  () => {
    return `/api/training-runs/rollout-credentials`;
  };

/**
 * Set and drop the team's rollout values; names it does not mention keep
 * theirs, and only names come back.
 *
 * Team members own these (TRA-1215): the Settings page is where a
 * customer enters what their agent needs at run time. Impersonation is
 * read-only, so staff never write here. The platform-managed training
 * key is minted at launch and is never one of them.
 * @summary Set Training Rollout Credentials
 */
export const setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPut =
  async (
    trainingRolloutCredentialsRequest: TrainingRolloutCredentialsRequest,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponse> => {
    const getHeaders = (
      h?: NonNullable<RequestInit["headers"]>,
    ): Record<string, string | readonly string[]> => {
      if (!h) return {};
      if (h instanceof Headers) return Object.fromEntries(h.entries());
      if (Symbol.iterator in h) {
        return Object.fromEntries(
          Array.from(
            h as Iterable<Iterable<string>>,
            (entry) => Array.from(entry) as [string, string],
          ),
        );
      }
      const headers: Record<string, string | readonly string[]> = {};
      for (const [name, value] of Object.entries<
        string | readonly string[] | undefined
      >(h)) {
        if (value !== undefined) headers[name] = value;
      }
      return headers;
    };
    return orvalFetch<setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutResponse>(
      getSetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutUrl(),
      {
        ...options,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(options?.headers),
        },
        body: JSON.stringify(trainingRolloutCredentialsRequest),
      },
    );
  };

export const getSetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationKey =
  () =>
    [
      "setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPut",
    ] as const;

export const getSetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPut
        >
      >,
      TError,
      SetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPut
      >
    >,
    TError,
    SetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getSetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPut
        >
      >,
      SetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPut(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPut
      >
    >
  >;
export type SetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationBody =
  TrainingRolloutCredentialsRequest;
export type SetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationError =
  ErrorType<HTTPValidationError>;
export type SetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationVariables =
  { data: TrainingRolloutCredentialsRequest };

/**
 * @summary Set Training Rollout Credentials
 */
export const useSetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPut =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPut
          >
        >,
        TError,
        SetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPut
      >
    >,
    TError,
    SetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationVariables,
    TContext
  > => {
    return useMutation(
      getSetTrainingRolloutCredentialsApiTrainingRunsRolloutCredentialsPutMutationOptions(
        options,
      ),
      queryClient,
    );
  };
export type listTrainingSetOptionsApiTrainingRunsSetsGetResponse200 = {
  data: TrainingSetOptionsResponse;
  status: 200;
};

export type listTrainingSetOptionsApiTrainingRunsSetsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTrainingSetOptionsApiTrainingRunsSetsGetResponseSuccess =
  listTrainingSetOptionsApiTrainingRunsSetsGetResponse200 & {
    headers: Headers;
  };
export type listTrainingSetOptionsApiTrainingRunsSetsGetResponseError =
  listTrainingSetOptionsApiTrainingRunsSetsGetResponse422 & {
    headers: Headers;
  };

export type listTrainingSetOptionsApiTrainingRunsSetsGetResponse =
  | listTrainingSetOptionsApiTrainingRunsSetsGetResponseSuccess
  | listTrainingSetOptionsApiTrainingRunsSetsGetResponseError;

export const getListTrainingSetOptionsApiTrainingRunsSetsGetUrl = () => {
  return `/api/training-runs/sets`;
};

/**
 * Published keeper sets the button can SFT on, newest first, and what
 * the dialog's Advanced section may change in the preset their recipe
 * derives (TRA-1345).
 * @summary List Training Set Options
 */
export const listTrainingSetOptionsApiTrainingRunsSetsGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTrainingSetOptionsApiTrainingRunsSetsGetResponse> => {
  return orvalFetch<listTrainingSetOptionsApiTrainingRunsSetsGetResponse>(
    getListTrainingSetOptionsApiTrainingRunsSetsGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTrainingSetOptionsApiTrainingRunsSetsGetQueryKey = () => {
  return [`/api/training-runs/sets`] as const;
};

export const getListTrainingSetOptionsApiTrainingRunsSetsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTrainingSetOptionsApiTrainingRunsSetsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>>
  > = ({ signal }) =>
    listTrainingSetOptionsApiTrainingRunsSetsGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTrainingSetOptionsApiTrainingRunsSetsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>>
  >;
export type ListTrainingSetOptionsApiTrainingRunsSetsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTrainingSetOptionsApiTrainingRunsSetsGet<
  TData = Awaited<
    ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTrainingSetOptionsApiTrainingRunsSetsGet<
  TData = Awaited<
    ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTrainingSetOptionsApiTrainingRunsSetsGet<
  TData = Awaited<
    ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Training Set Options
 */

export function useListTrainingSetOptionsApiTrainingRunsSetsGet<
  TData = Awaited<
    ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingSetOptionsApiTrainingRunsSetsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListTrainingSetOptionsApiTrainingRunsSetsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type uploadTrainingSetApiTrainingRunsSetsPostResponse201 = {
  data: TrainingSetOption;
  status: 201;
};

export type uploadTrainingSetApiTrainingRunsSetsPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type uploadTrainingSetApiTrainingRunsSetsPostResponseSuccess =
  uploadTrainingSetApiTrainingRunsSetsPostResponse201 & {
    headers: Headers;
  };
export type uploadTrainingSetApiTrainingRunsSetsPostResponseError =
  uploadTrainingSetApiTrainingRunsSetsPostResponse422 & {
    headers: Headers;
  };

export type uploadTrainingSetApiTrainingRunsSetsPostResponse =
  | uploadTrainingSetApiTrainingRunsSetsPostResponseSuccess
  | uploadTrainingSetApiTrainingRunsSetsPostResponseError;

export const getUploadTrainingSetApiTrainingRunsSetsPostUrl = () => {
  return `/api/training-runs/sets`;
};

/**
 * Staff-only: publish a training and a validation file as a new set of
 * a team the staff member belongs to (`get_member_team_id`: never a demo
 * team they only view), launchable like a keeper set
 * (services/training_sets.py).
 * @summary Upload Training Set
 */
export const uploadTrainingSetApiTrainingRunsSetsPost = async (
  trainingSetUploadRequest: TrainingSetUploadRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<uploadTrainingSetApiTrainingRunsSetsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<uploadTrainingSetApiTrainingRunsSetsPostResponse>(
    getUploadTrainingSetApiTrainingRunsSetsPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(trainingSetUploadRequest),
    },
  );
};

export const getUploadTrainingSetApiTrainingRunsSetsPostMutationKey = () =>
  ["uploadTrainingSetApiTrainingRunsSetsPost"] as const;

export const getUploadTrainingSetApiTrainingRunsSetsPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadTrainingSetApiTrainingRunsSetsPost>>,
    TError,
    UploadTrainingSetApiTrainingRunsSetsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadTrainingSetApiTrainingRunsSetsPost>>,
  TError,
  UploadTrainingSetApiTrainingRunsSetsPostMutationVariables,
  TContext
> => {
  const mutationKey = getUploadTrainingSetApiTrainingRunsSetsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadTrainingSetApiTrainingRunsSetsPost>>,
    UploadTrainingSetApiTrainingRunsSetsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return uploadTrainingSetApiTrainingRunsSetsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadTrainingSetApiTrainingRunsSetsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof uploadTrainingSetApiTrainingRunsSetsPost>>
  >;
export type UploadTrainingSetApiTrainingRunsSetsPostMutationBody =
  TrainingSetUploadRequest;
export type UploadTrainingSetApiTrainingRunsSetsPostMutationError =
  ErrorType<HTTPValidationError>;
export type UploadTrainingSetApiTrainingRunsSetsPostMutationVariables = {
  data: TrainingSetUploadRequest;
};

/**
 * @summary Upload Training Set
 */
export const useUploadTrainingSetApiTrainingRunsSetsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadTrainingSetApiTrainingRunsSetsPost>>,
      TError,
      UploadTrainingSetApiTrainingRunsSetsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadTrainingSetApiTrainingRunsSetsPost>>,
  TError,
  UploadTrainingSetApiTrainingRunsSetsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getUploadTrainingSetApiTrainingRunsSetsPostMutationOptions(options),
    queryClient,
  );
};
export type getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponse200 =
  {
    data: GrpoRecipeValues;
    status: 200;
  };

export type getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponseSuccess =
  getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponse200 & {
    headers: Headers;
  };
export type getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponseError =
  getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponse422 & {
    headers: Headers;
  };

export type getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponse =
  | getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponseSuccess
  | getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponseError;

export const getGetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetUrl = (
  params: GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/training-runs/grpo/preset?${stringifiedParams}`
    : `/api/training-runs/grpo/preset`;
};

/**
 * An RL preset's current recipe values at the pinned trainer, which the
 * launch dialog shows beside the fields a launch may change.
 * @summary Get Training Grpo Preset Values
 */
export const getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet = async (
  params: GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponse> => {
  return orvalFetch<getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetResponse>(
    getGetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetQueryKey =
  (params?: GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetParams) => {
    return [
      `/api/training-runs/grpo/preset`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    params: GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetQueryKey(
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
        >
      >
    > = ({ signal }) =>
      getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet(params, {
        signal,
        ...requestOptions,
      });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet>
    >
  >;
export type GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet<
  TData = Awaited<
    ReturnType<typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  params: GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet<
  TData = Awaited<
    ReturnType<typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  params: GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet<
  TData = Awaited<
    ReturnType<typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  params: GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Training Grpo Preset Values
 */

export function useGetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet<
  TData = Awaited<
    ReturnType<typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  params: GetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTrainingGrpoPresetValuesApiTrainingRunsGrpoPresetGetQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponse200 = {
  data: TrainingGrpoOptionsResponse;
  status: 200;
};

export type listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponseSuccess =
  listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponse200 & {
    headers: Headers;
  };
export type listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponseError =
  listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponse422 & {
    headers: Headers;
  };

export type listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponse =
  | listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponseSuccess
  | listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponseError;

export const getListTrainingGrpoOptionsApiTrainingRunsGrpoGetUrl = () => {
  return `/api/training-runs/grpo`;
};

/**
 * The team's GRPO registry datasets, the validation datasets a run can
 * score, the presets the dialog offers and the one it offers first.
 * @summary List Training Grpo Options
 */
export const listTrainingGrpoOptionsApiTrainingRunsGrpoGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponse> => {
  return orvalFetch<listTrainingGrpoOptionsApiTrainingRunsGrpoGetResponse>(
    getListTrainingGrpoOptionsApiTrainingRunsGrpoGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTrainingGrpoOptionsApiTrainingRunsGrpoGetQueryKey = () => {
  return [`/api/training-runs/grpo`] as const;
};

export const getListTrainingGrpoOptionsApiTrainingRunsGrpoGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTrainingGrpoOptionsApiTrainingRunsGrpoGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>>
  > = ({ signal }) =>
    listTrainingGrpoOptionsApiTrainingRunsGrpoGet({
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTrainingGrpoOptionsApiTrainingRunsGrpoGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>>
  >;
export type ListTrainingGrpoOptionsApiTrainingRunsGrpoGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTrainingGrpoOptionsApiTrainingRunsGrpoGet<
  TData = Awaited<
    ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTrainingGrpoOptionsApiTrainingRunsGrpoGet<
  TData = Awaited<
    ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTrainingGrpoOptionsApiTrainingRunsGrpoGet<
  TData = Awaited<
    ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Training Grpo Options
 */

export function useListTrainingGrpoOptionsApiTrainingRunsGrpoGet<
  TData = Awaited<
    ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingGrpoOptionsApiTrainingRunsGrpoGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListTrainingGrpoOptionsApiTrainingRunsGrpoGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type registerTrainingSetApiTrainingRunsSetsRegisterPostResponse202 = {
  data: TrainingSetRegistration;
  status: 202;
};

export type registerTrainingSetApiTrainingRunsSetsRegisterPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type registerTrainingSetApiTrainingRunsSetsRegisterPostResponseSuccess =
  registerTrainingSetApiTrainingRunsSetsRegisterPostResponse202 & {
    headers: Headers;
  };
export type registerTrainingSetApiTrainingRunsSetsRegisterPostResponseError =
  registerTrainingSetApiTrainingRunsSetsRegisterPostResponse422 & {
    headers: Headers;
  };

export type registerTrainingSetApiTrainingRunsSetsRegisterPostResponse =
  | registerTrainingSetApiTrainingRunsSetsRegisterPostResponseSuccess
  | registerTrainingSetApiTrainingRunsSetsRegisterPostResponseError;

export const getRegisterTrainingSetApiTrainingRunsSetsRegisterPostUrl = () => {
  return `/api/training-runs/sets/register`;
};

/**
 * Staff-only: publish the train.jsonl and validation.jsonl copied under
 * the team's staging folder as a new set, for a set too large for one
 * upload (TRA-1559, services/training_sets.py). The api checks them in the
 * background, as it checks an upload; poll GET /sets/register/{set_id}.
 * @summary Register Training Set
 */
export const registerTrainingSetApiTrainingRunsSetsRegisterPost = async (
  trainingSetRegisterRequest: TrainingSetRegisterRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<registerTrainingSetApiTrainingRunsSetsRegisterPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<registerTrainingSetApiTrainingRunsSetsRegisterPostResponse>(
    getRegisterTrainingSetApiTrainingRunsSetsRegisterPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(trainingSetRegisterRequest),
    },
  );
};

export const getRegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationKey =
  () => ["registerTrainingSetApiTrainingRunsSetsRegisterPost"] as const;

export const getRegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof registerTrainingSetApiTrainingRunsSetsRegisterPost>
      >,
      TError,
      RegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof registerTrainingSetApiTrainingRunsSetsRegisterPost>
    >,
    TError,
    RegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getRegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof registerTrainingSetApiTrainingRunsSetsRegisterPost>
      >,
      RegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return registerTrainingSetApiTrainingRunsSetsRegisterPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof registerTrainingSetApiTrainingRunsSetsRegisterPost>
    >
  >;
export type RegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationBody =
  TrainingSetRegisterRequest;
export type RegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationError =
  ErrorType<HTTPValidationError>;
export type RegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationVariables =
  { data: TrainingSetRegisterRequest };

/**
 * @summary Register Training Set
 */
export const useRegisterTrainingSetApiTrainingRunsSetsRegisterPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof registerTrainingSetApiTrainingRunsSetsRegisterPost>
      >,
      TError,
      RegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof registerTrainingSetApiTrainingRunsSetsRegisterPost>
  >,
  TError,
  RegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationVariables,
  TContext
> => {
  return useMutation(
    getRegisterTrainingSetApiTrainingRunsSetsRegisterPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponse200 =
  {
    data: TrainingSetRegistration;
    status: 200;
  };

export type getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponseSuccess =
  getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponse200 & {
    headers: Headers;
  };
export type getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponseError =
  getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponse422 & {
    headers: Headers;
  };

export type getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponse =

    | getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponseSuccess
    | getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponseError;

export const getGetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetUrl =
  (setId: string) => {
    return `/api/training-runs/sets/register/${setId}`;
  };

/**
 * A registration from the staging folder as it stands: checking (with
 * the bytes read so far), registered, or refused and why.
 * @summary Get Training Set Registration
 */
export const getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet =
  async (
    setId: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponse> => {
    return orvalFetch<getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetResponse>(
      getGetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetUrl(
        setId,
      ),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getGetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetQueryKey =
  (setId: string) => {
    return [`/api/training-runs/sets/register/${setId}`] as const;
  };

export const getGetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    setId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetQueryKey(
        setId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
        >
      >
    > = ({ signal }) =>
      getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet(setId, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: setId !== null && setId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
      >
    >
  >;
export type GetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  setId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  setId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  setId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Training Set Registration
 */

export function useGetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  setId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTrainingSetRegistrationApiTrainingRunsSetsRegisterSetIdGetQueryOptions(
      setId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponse201 =
  {
    data: TrainingSetStagingUpload;
    status: 201;
  };

export type signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponseSuccess =
  signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponse201 & {
    headers: Headers;
  };
export type signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponseError =
  signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponse422 & {
    headers: Headers;
  };

export type signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponse =
  | signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponseSuccess
  | signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponseError;

export const getSignStagingUploadApiTrainingRunsSetsStagingUploadsPostUrl =
  () => {
    return `/api/training-runs/sets/staging-uploads`;
  };

/**
 * Staff-only, where the stack signs them (TRAINING_SET_UPLOAD_SIGNER):
 * a URL that starts a resumable upload of one file of a set straight into
 * the team's staging folder, for a set too large for one upload
 * (services/gcs_signing.py). Register the set once both files are there.
 * @summary Sign Staging Upload
 */
export const signStagingUploadApiTrainingRunsSetsStagingUploadsPost = async (
  trainingSetStagingUploadRequest: TrainingSetStagingUploadRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<signStagingUploadApiTrainingRunsSetsStagingUploadsPostResponse>(
    getSignStagingUploadApiTrainingRunsSetsStagingUploadsPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(trainingSetStagingUploadRequest),
    },
  );
};

export const getSignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationKey =
  () => ["signStagingUploadApiTrainingRunsSetsStagingUploadsPost"] as const;

export const getSignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof signStagingUploadApiTrainingRunsSetsStagingUploadsPost
        >
      >,
      TError,
      SignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof signStagingUploadApiTrainingRunsSetsStagingUploadsPost>
    >,
    TError,
    SignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getSignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof signStagingUploadApiTrainingRunsSetsStagingUploadsPost
        >
      >,
      SignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return signStagingUploadApiTrainingRunsSetsStagingUploadsPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof signStagingUploadApiTrainingRunsSetsStagingUploadsPost>
    >
  >;
export type SignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationBody =
  TrainingSetStagingUploadRequest;
export type SignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationError =
  ErrorType<HTTPValidationError>;
export type SignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationVariables =
  { data: TrainingSetStagingUploadRequest };

/**
 * @summary Sign Staging Upload
 */
export const useSignStagingUploadApiTrainingRunsSetsStagingUploadsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof signStagingUploadApiTrainingRunsSetsStagingUploadsPost
        >
      >,
      TError,
      SignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof signStagingUploadApiTrainingRunsSetsStagingUploadsPost>
  >,
  TError,
  SignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getSignStagingUploadApiTrainingRunsSetsStagingUploadsPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type getHeldOutTestsApiTrainingRunsHeldOutGetResponse200 = {
  data: HeldOutTestsResponse;
  status: 200;
};

export type getHeldOutTestsApiTrainingRunsHeldOutGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getHeldOutTestsApiTrainingRunsHeldOutGetResponseSuccess =
  getHeldOutTestsApiTrainingRunsHeldOutGetResponse200 & {
    headers: Headers;
  };
export type getHeldOutTestsApiTrainingRunsHeldOutGetResponseError =
  getHeldOutTestsApiTrainingRunsHeldOutGetResponse422 & {
    headers: Headers;
  };

export type getHeldOutTestsApiTrainingRunsHeldOutGetResponse =
  | getHeldOutTestsApiTrainingRunsHeldOutGetResponseSuccess
  | getHeldOutTestsApiTrainingRunsHeldOutGetResponseError;

export const getGetHeldOutTestsApiTrainingRunsHeldOutGetUrl = () => {
  return `/api/training-runs/held-out`;
};

/**
 * Staff-only: the selected team's held-out tests and the tests of its
 * latest scoring night to pick them from (TRA-1434).
 * @summary Get Held Out Tests
 */
export const getHeldOutTestsApiTrainingRunsHeldOutGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getHeldOutTestsApiTrainingRunsHeldOutGetResponse> => {
  return orvalFetch<getHeldOutTestsApiTrainingRunsHeldOutGetResponse>(
    getGetHeldOutTestsApiTrainingRunsHeldOutGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetHeldOutTestsApiTrainingRunsHeldOutGetQueryKey = () => {
  return [`/api/training-runs/held-out`] as const;
};

export const getGetHeldOutTestsApiTrainingRunsHeldOutGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetHeldOutTestsApiTrainingRunsHeldOutGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>
  > = ({ signal }) =>
    getHeldOutTestsApiTrainingRunsHeldOutGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeldOutTestsApiTrainingRunsHeldOutGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>
>;
export type GetHeldOutTestsApiTrainingRunsHeldOutGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetHeldOutTestsApiTrainingRunsHeldOutGet<
  TData = Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
          TError,
          Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHeldOutTestsApiTrainingRunsHeldOutGet<
  TData = Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
          TError,
          Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHeldOutTestsApiTrainingRunsHeldOutGet<
  TData = Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Held Out Tests
 */

export function useGetHeldOutTestsApiTrainingRunsHeldOutGet<
  TData = Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHeldOutTestsApiTrainingRunsHeldOutGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetHeldOutTestsApiTrainingRunsHeldOutGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type saveHeldOutTestsApiTrainingRunsHeldOutPutResponse200 = {
  data: HeldOutTestsResponse;
  status: 200;
};

export type saveHeldOutTestsApiTrainingRunsHeldOutPutResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type saveHeldOutTestsApiTrainingRunsHeldOutPutResponseSuccess =
  saveHeldOutTestsApiTrainingRunsHeldOutPutResponse200 & {
    headers: Headers;
  };
export type saveHeldOutTestsApiTrainingRunsHeldOutPutResponseError =
  saveHeldOutTestsApiTrainingRunsHeldOutPutResponse422 & {
    headers: Headers;
  };

export type saveHeldOutTestsApiTrainingRunsHeldOutPutResponse =
  | saveHeldOutTestsApiTrainingRunsHeldOutPutResponseSuccess
  | saveHeldOutTestsApiTrainingRunsHeldOutPutResponseError;

export const getSaveHeldOutTestsApiTrainingRunsHeldOutPutUrl = () => {
  return `/api/training-runs/held-out`;
};

/**
 * Staff-only: replace the held-out tests of a team the staff member
 * belongs to (`get_member_team_id`: never a demo team they only view).
 * Once a team has them, its training dataset can build (the staff Jobs
 * page and the chain's dataset link both wait on this file).
 * @summary Save Held Out Tests
 */
export const saveHeldOutTestsApiTrainingRunsHeldOutPut = async (
  heldOutTestsUpdate: HeldOutTestsUpdate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<saveHeldOutTestsApiTrainingRunsHeldOutPutResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<saveHeldOutTestsApiTrainingRunsHeldOutPutResponse>(
    getSaveHeldOutTestsApiTrainingRunsHeldOutPutUrl(),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(heldOutTestsUpdate),
    },
  );
};

export const getSaveHeldOutTestsApiTrainingRunsHeldOutPutMutationKey = () =>
  ["saveHeldOutTestsApiTrainingRunsHeldOutPut"] as const;

export const getSaveHeldOutTestsApiTrainingRunsHeldOutPutMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveHeldOutTestsApiTrainingRunsHeldOutPut>>,
    TError,
    SaveHeldOutTestsApiTrainingRunsHeldOutPutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveHeldOutTestsApiTrainingRunsHeldOutPut>>,
  TError,
  SaveHeldOutTestsApiTrainingRunsHeldOutPutMutationVariables,
  TContext
> => {
  const mutationKey = getSaveHeldOutTestsApiTrainingRunsHeldOutPutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveHeldOutTestsApiTrainingRunsHeldOutPut>>,
    SaveHeldOutTestsApiTrainingRunsHeldOutPutMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return saveHeldOutTestsApiTrainingRunsHeldOutPut(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveHeldOutTestsApiTrainingRunsHeldOutPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof saveHeldOutTestsApiTrainingRunsHeldOutPut>>
  >;
export type SaveHeldOutTestsApiTrainingRunsHeldOutPutMutationBody =
  HeldOutTestsUpdate;
export type SaveHeldOutTestsApiTrainingRunsHeldOutPutMutationError =
  ErrorType<HTTPValidationError>;
export type SaveHeldOutTestsApiTrainingRunsHeldOutPutMutationVariables = {
  data: HeldOutTestsUpdate;
};

/**
 * @summary Save Held Out Tests
 */
export const useSaveHeldOutTestsApiTrainingRunsHeldOutPut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveHeldOutTestsApiTrainingRunsHeldOutPut>>,
      TError,
      SaveHeldOutTestsApiTrainingRunsHeldOutPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveHeldOutTestsApiTrainingRunsHeldOutPut>>,
  TError,
  SaveHeldOutTestsApiTrainingRunsHeldOutPutMutationVariables,
  TContext
> => {
  return useMutation(
    getSaveHeldOutTestsApiTrainingRunsHeldOutPutMutationOptions(options),
    queryClient,
  );
};
export type launchTrainingRunApiTrainingRunsLaunchPostResponse201 = {
  data: TrainingLaunchView;
  status: 201;
};

export type launchTrainingRunApiTrainingRunsLaunchPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type launchTrainingRunApiTrainingRunsLaunchPostResponseSuccess =
  launchTrainingRunApiTrainingRunsLaunchPostResponse201 & {
    headers: Headers;
  };
export type launchTrainingRunApiTrainingRunsLaunchPostResponseError =
  launchTrainingRunApiTrainingRunsLaunchPostResponse422 & {
    headers: Headers;
  };

export type launchTrainingRunApiTrainingRunsLaunchPostResponse =
  | launchTrainingRunApiTrainingRunsLaunchPostResponseSuccess
  | launchTrainingRunApiTrainingRunsLaunchPostResponseError;

export const getLaunchTrainingRunApiTrainingRunsLaunchPostUrl = () => {
  return `/api/training-runs/launch`;
};

/**
 * Staff-only: write the run row, mint its token, create the launcher Job.
 *
 * 409 while any run in the system is ``running`` (the DB's partial unique
 * index decides, not a check-then-insert). A Job that cannot be created
 * marks the row failed and returns 503, so the page never shows a run
 * that no node will ever pick up.
 * @summary Launch Training Run
 */
export const launchTrainingRunApiTrainingRunsLaunchPost = async (
  trainingLaunchRequest: TrainingLaunchRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<launchTrainingRunApiTrainingRunsLaunchPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<launchTrainingRunApiTrainingRunsLaunchPostResponse>(
    getLaunchTrainingRunApiTrainingRunsLaunchPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(trainingLaunchRequest),
    },
  );
};

export const getLaunchTrainingRunApiTrainingRunsLaunchPostMutationKey = () =>
  ["launchTrainingRunApiTrainingRunsLaunchPost"] as const;

export const getLaunchTrainingRunApiTrainingRunsLaunchPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof launchTrainingRunApiTrainingRunsLaunchPost>>,
    TError,
    LaunchTrainingRunApiTrainingRunsLaunchPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof launchTrainingRunApiTrainingRunsLaunchPost>>,
  TError,
  LaunchTrainingRunApiTrainingRunsLaunchPostMutationVariables,
  TContext
> => {
  const mutationKey =
    getLaunchTrainingRunApiTrainingRunsLaunchPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof launchTrainingRunApiTrainingRunsLaunchPost>>,
    LaunchTrainingRunApiTrainingRunsLaunchPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return launchTrainingRunApiTrainingRunsLaunchPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LaunchTrainingRunApiTrainingRunsLaunchPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof launchTrainingRunApiTrainingRunsLaunchPost>>
  >;
export type LaunchTrainingRunApiTrainingRunsLaunchPostMutationBody =
  TrainingLaunchRequest;
export type LaunchTrainingRunApiTrainingRunsLaunchPostMutationError =
  ErrorType<HTTPValidationError>;
export type LaunchTrainingRunApiTrainingRunsLaunchPostMutationVariables = {
  data: TrainingLaunchRequest;
};

/**
 * @summary Launch Training Run
 */
export const useLaunchTrainingRunApiTrainingRunsLaunchPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof launchTrainingRunApiTrainingRunsLaunchPost>>,
      TError,
      LaunchTrainingRunApiTrainingRunsLaunchPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof launchTrainingRunApiTrainingRunsLaunchPost>>,
  TError,
  LaunchTrainingRunApiTrainingRunsLaunchPostMutationVariables,
  TContext
> => {
  return useMutation(
    getLaunchTrainingRunApiTrainingRunsLaunchPostMutationOptions(options),
    queryClient,
  );
};
export type serveTrainingRunApiTrainingRunsRunIdServePostResponse201 = {
  data: TrainingLaunchView;
  status: 201;
};

export type serveTrainingRunApiTrainingRunsRunIdServePostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type serveTrainingRunApiTrainingRunsRunIdServePostResponseSuccess =
  serveTrainingRunApiTrainingRunsRunIdServePostResponse201 & {
    headers: Headers;
  };
export type serveTrainingRunApiTrainingRunsRunIdServePostResponseError =
  serveTrainingRunApiTrainingRunsRunIdServePostResponse422 & {
    headers: Headers;
  };

export type serveTrainingRunApiTrainingRunsRunIdServePostResponse =
  | serveTrainingRunApiTrainingRunsRunIdServePostResponseSuccess
  | serveTrainingRunApiTrainingRunsRunIdServePostResponseError;

export const getServeTrainingRunApiTrainingRunsRunIdServePostUrl = (
  runId: string,
) => {
  return `/api/training-runs/${runId}/serve`;
};

/**
 * Staff-only: deploy the best step of a grpo run whose own export
 * failed, on a CPU node its own launcher Job starts (a serve row, kind
 * serve). Its completed callback completes the run and starts the run's
 * held-out eval (report_training_status).
 *
 * It takes no body: it serves the run's best_artifact, the step the
 * held-out eval scores. 409 with the reason when the run cannot be served
 * (training_launch.serve_refusal), checked before any row or Job and
 * again once the serve holds the slot, and 409 while any run holds the
 * stack's slot, as a launch. It deploys to Baseten for the team and
 * completes its run, so only on a team the staff member belongs to
 * (`get_member_team_id`: never a demo team they only view).
 * @summary Serve Training Run
 */
export const serveTrainingRunApiTrainingRunsRunIdServePost = async (
  runId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<serveTrainingRunApiTrainingRunsRunIdServePostResponse> => {
  return orvalFetch<serveTrainingRunApiTrainingRunsRunIdServePostResponse>(
    getServeTrainingRunApiTrainingRunsRunIdServePostUrl(runId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getServeTrainingRunApiTrainingRunsRunIdServePostMutationKey = () =>
  ["serveTrainingRunApiTrainingRunsRunIdServePost"] as const;

export const getServeTrainingRunApiTrainingRunsRunIdServePostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof serveTrainingRunApiTrainingRunsRunIdServePost>>,
    TError,
    ServeTrainingRunApiTrainingRunsRunIdServePostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof serveTrainingRunApiTrainingRunsRunIdServePost>>,
  TError,
  ServeTrainingRunApiTrainingRunsRunIdServePostMutationVariables,
  TContext
> => {
  const mutationKey =
    getServeTrainingRunApiTrainingRunsRunIdServePostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof serveTrainingRunApiTrainingRunsRunIdServePost>>,
    ServeTrainingRunApiTrainingRunsRunIdServePostMutationVariables
  > = (props) => {
    const { runId } = props ?? {};

    return serveTrainingRunApiTrainingRunsRunIdServePost(runId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ServeTrainingRunApiTrainingRunsRunIdServePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof serveTrainingRunApiTrainingRunsRunIdServePost>>
  >;

export type ServeTrainingRunApiTrainingRunsRunIdServePostMutationError =
  ErrorType<HTTPValidationError>;
export type ServeTrainingRunApiTrainingRunsRunIdServePostMutationVariables = {
  runId: string;
};

/**
 * @summary Serve Training Run
 */
export const useServeTrainingRunApiTrainingRunsRunIdServePost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof serveTrainingRunApiTrainingRunsRunIdServePost>>,
      TError,
      ServeTrainingRunApiTrainingRunsRunIdServePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof serveTrainingRunApiTrainingRunsRunIdServePost>>,
  TError,
  ServeTrainingRunApiTrainingRunsRunIdServePostMutationVariables,
  TContext
> => {
  return useMutation(
    getServeTrainingRunApiTrainingRunsRunIdServePostMutationOptions(options),
    queryClient,
  );
};
export type recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponse200 =
  {
    data: TrainingRunDocument;
    status: 200;
  };

export type recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponseSuccess =
  recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponse200 & {
    headers: Headers;
  };
export type recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponseError =
  recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponse422 & {
    headers: Headers;
  };

export type recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponse =
  | recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponseSuccess
  | recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponseError;

export const getRecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostUrl =
  (runId: string) => {
    return `/api/training-runs/${runId}/deployment`;
  };

/**
 * Staff-only, on an enterprise install: record that the cluster's
 * admins applied a completed SFT set run's sealed adapter as a LoRA
 * module of the vLLM Deployment serving its base, under a team model
 * staff registered for it on the Models page (TRA-1600; the
 * pfizer-training skill has the operator steps). The run's run.json then
 * records the deployment in promoted_to, and the page shows it. Nothing
 * is deployed here: the Deployment is applied outside the platform, and
 * this is the one write that ties the run to it.
 *
 * 409 with the reason when the run cannot take one
 * (training_launch.deployment_refusal), when the model is a catalog
 * model, or when its route forwards to no served model; 404 for a run or
 * a model of another team; 502 when the bucket or the gateway cannot
 * answer. Only on a team the staff member belongs to (`get_member_team_id`).
 *
 * The run's row is read under its lock, held until the request's
 * transaction ends, after the bucket write: two staff recording one run
 * at once are serialized on it, and the second reads run.json after the
 * first wrote it and gets "This run has a deployment already" rather
 * than replacing the first's record (Devin on #1340).
 * @summary Record Training Deployment
 */
export const recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPost =
  async (
    runId: string,
    trainingDeploymentRecord: TrainingDeploymentRecord,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponse> => {
    const getHeaders = (
      h?: NonNullable<RequestInit["headers"]>,
    ): Record<string, string | readonly string[]> => {
      if (!h) return {};
      if (h instanceof Headers) return Object.fromEntries(h.entries());
      if (Symbol.iterator in h) {
        return Object.fromEntries(
          Array.from(
            h as Iterable<Iterable<string>>,
            (entry) => Array.from(entry) as [string, string],
          ),
        );
      }
      const headers: Record<string, string | readonly string[]> = {};
      for (const [name, value] of Object.entries<
        string | readonly string[] | undefined
      >(h)) {
        if (value !== undefined) headers[name] = value;
      }
      return headers;
    };
    return orvalFetch<recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostResponse>(
      getRecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostUrl(runId),
      {
        ...options,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(options?.headers),
        },
        body: JSON.stringify(trainingDeploymentRecord),
      },
    );
  };

export const getRecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationKey =
  () => ["recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPost"] as const;

export const getRecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPost
        >
      >,
      TError,
      RecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPost
      >
    >,
    TError,
    RecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getRecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPost
        >
      >,
      RecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationVariables
    > = (props) => {
      const { runId, data } = props ?? {};

      return recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPost(
        runId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPost
      >
    >
  >;
export type RecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationBody =
  TrainingDeploymentRecord;
export type RecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationError =
  ErrorType<HTTPValidationError>;
export type RecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationVariables =
  { runId: string; data: TrainingDeploymentRecord };

/**
 * @summary Record Training Deployment
 */
export const useRecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPost
        >
      >,
      TError,
      RecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof recordTrainingDeploymentApiTrainingRunsRunIdDeploymentPost
    >
  >,
  TError,
  RecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationVariables,
  TContext
> => {
  return useMutation(
    getRecordTrainingDeploymentApiTrainingRunsRunIdDeploymentPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type reportTrainingStatusApiTrainingRunsRunIdStatusPostResponse200 = {
  data: TrainingLaunchView;
  status: 200;
};

export type reportTrainingStatusApiTrainingRunsRunIdStatusPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type reportTrainingStatusApiTrainingRunsRunIdStatusPostResponseSuccess =
  reportTrainingStatusApiTrainingRunsRunIdStatusPostResponse200 & {
    headers: Headers;
  };
export type reportTrainingStatusApiTrainingRunsRunIdStatusPostResponseError =
  reportTrainingStatusApiTrainingRunsRunIdStatusPostResponse422 & {
    headers: Headers;
  };

export type reportTrainingStatusApiTrainingRunsRunIdStatusPostResponse =
  | reportTrainingStatusApiTrainingRunsRunIdStatusPostResponseSuccess
  | reportTrainingStatusApiTrainingRunsRunIdStatusPostResponseError;

export const getReportTrainingStatusApiTrainingRunsRunIdStatusPostUrl = (
  runId: string,
) => {
  return `/api/training-runs/${runId}/status`;
};

/**
 * The node's status callback, authenticated by the per-run token.
 *
 * Forward-only: ``running`` may repeat with a new message; a terminal
 * status ends the run and the token, so any later call is 409, with the
 * status the row holds in ``RUN_STATUS_HEADER``. A serve
 * that reports completed also completes the failed run it served, in the
 * same commit (_serve_completed), and 422 changes neither row while the
 * run's run.json records no deployment. A completed grpo run, or the run
 * a serve completed, starts its held-out eval once committed.
 * @summary Report Training Status
 */
export const reportTrainingStatusApiTrainingRunsRunIdStatusPost = async (
  runId: string,
  trainingStatusRequest: TrainingStatusRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<reportTrainingStatusApiTrainingRunsRunIdStatusPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<reportTrainingStatusApiTrainingRunsRunIdStatusPostResponse>(
    getReportTrainingStatusApiTrainingRunsRunIdStatusPostUrl(runId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(trainingStatusRequest),
    },
  );
};

export const getReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationKey =
  () => ["reportTrainingStatusApiTrainingRunsRunIdStatusPost"] as const;

export const getReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof reportTrainingStatusApiTrainingRunsRunIdStatusPost>
      >,
      TError,
      ReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof reportTrainingStatusApiTrainingRunsRunIdStatusPost>
    >,
    TError,
    ReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof reportTrainingStatusApiTrainingRunsRunIdStatusPost>
      >,
      ReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationVariables
    > = (props) => {
      const { runId, data } = props ?? {};

      return reportTrainingStatusApiTrainingRunsRunIdStatusPost(
        runId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof reportTrainingStatusApiTrainingRunsRunIdStatusPost>
    >
  >;
export type ReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationBody =
  TrainingStatusRequest;
export type ReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationError =
  ErrorType<HTTPValidationError>;
export type ReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationVariables =
  { runId: string; data: TrainingStatusRequest };

/**
 * @summary Report Training Status
 */
export const useReportTrainingStatusApiTrainingRunsRunIdStatusPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof reportTrainingStatusApiTrainingRunsRunIdStatusPost>
      >,
      TError,
      ReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof reportTrainingStatusApiTrainingRunsRunIdStatusPost>
  >,
  TError,
  ReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationVariables,
  TContext
> => {
  return useMutation(
    getReportTrainingStatusApiTrainingRunsRunIdStatusPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponse202 = {
  data: HeldOutEvalStartResponse;
  status: 202;
};

export type scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponseSuccess =
  scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponse202 & {
    headers: Headers;
  };
export type scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponseError =
  scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponse422 & {
    headers: Headers;
  };

export type scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponse =
  | scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponseSuccess
  | scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponseError;

export const getScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostUrl = (
  runId: string,
) => {
  return `/api/training-runs/${runId}/held-out-eval`;
};

/**
 * Staff-only: score a completed grpo run's served best step on the
 * team's held-out tests again, or for the first time when the automatic
 * start was lost. 409 for a run that is not a completed grpo run. It
 * spends the team's inference and rewrites its run document, so only on
 * a team the staff member belongs to (`get_member_team_id`: never a demo
 * team they only view).
 * @summary Score Held Out
 */
export const scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPost = async (
  runId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponse> => {
  return orvalFetch<scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostResponse>(
    getScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostUrl(runId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationKey =
  () => ["scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPost"] as const;

export const getScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPost>
      >,
      TError,
      ScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPost>>,
    TError,
    ScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPost>
      >,
      ScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationVariables
    > = (props) => {
      const { runId } = props ?? {};

      return scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPost(
        runId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPost>>
  >;

export type ScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationError =
  ErrorType<HTTPValidationError>;
export type ScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationVariables = {
  runId: string;
};

/**
 * @summary Score Held Out
 */
export const useScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPost>
      >,
      TError,
      ScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof scoreHeldOutApiTrainingRunsRunIdHeldOutEvalPost>>,
  TError,
  ScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationVariables,
  TContext
> => {
  return useMutation(
    getScoreHeldOutApiTrainingRunsRunIdHeldOutEvalPostMutationOptions(options),
    queryClient,
  );
};
export type makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponse200 = {
  data: ModelResponse;
  status: 200;
};

export type makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponseSuccess =
  makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponse200 & {
    headers: Headers;
  };
export type makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponseError =
  makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponse422 & {
    headers: Headers;
  };

export type makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponse =
  | makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponseSuccess
  | makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponseError;

export const getMakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostUrl = (
  runId: string,
) => {
  return `/api/training-runs/${runId}/make-default`;
};

/**
 * Staff-only: make a run's served step the team's default model, which
 * the nightly evals score from the next night (TRA-1368). Only on a team
 * the staff member belongs to (`get_member_team_id`: never a demo team
 * they only view).
 *
 * A person approves; the gate decides whether there is anything to
 * approve. 409 unless the run's held-out eval found the model eligible
 * and the default model is still the row that eval compared with
 * (services/default_gate.py ``refusal``), with the reason as the detail.
 * The default is read under its row lock (``lock_default_model``) in the
 * transaction that switches, so the check and the switch are one step:
 * another switch waits, and then finds the default it read gone. The
 * switch itself is the Models page's (``models.set_default_model``).
 * Idempotent on a model that is already the default.
 * @summary Make Run Default
 */
export const makeRunDefaultApiTrainingRunsRunIdMakeDefaultPost = async (
  runId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponse> => {
  return orvalFetch<makeRunDefaultApiTrainingRunsRunIdMakeDefaultPostResponse>(
    getMakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostUrl(runId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getMakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationKey =
  () => ["makeRunDefaultApiTrainingRunsRunIdMakeDefaultPost"] as const;

export const getMakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof makeRunDefaultApiTrainingRunsRunIdMakeDefaultPost>
      >,
      TError,
      MakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof makeRunDefaultApiTrainingRunsRunIdMakeDefaultPost>
    >,
    TError,
    MakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getMakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof makeRunDefaultApiTrainingRunsRunIdMakeDefaultPost>
      >,
      MakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationVariables
    > = (props) => {
      const { runId } = props ?? {};

      return makeRunDefaultApiTrainingRunsRunIdMakeDefaultPost(
        runId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof makeRunDefaultApiTrainingRunsRunIdMakeDefaultPost>
    >
  >;

export type MakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationError =
  ErrorType<HTTPValidationError>;
export type MakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationVariables =
  { runId: string };

/**
 * @summary Make Run Default
 */
export const useMakeRunDefaultApiTrainingRunsRunIdMakeDefaultPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof makeRunDefaultApiTrainingRunsRunIdMakeDefaultPost>
      >,
      TError,
      MakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof makeRunDefaultApiTrainingRunsRunIdMakeDefaultPost>>,
  TError,
  MakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationVariables,
  TContext
> => {
  return useMutation(
    getMakeRunDefaultApiTrainingRunsRunIdMakeDefaultPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponse200 = {
  data: TrainingCloneTokenResponse;
  status: 200;
};

export type mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponseSuccess =
  mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponse200 & {
    headers: Headers;
  };
export type mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponseError =
  mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponse422 & {
    headers: Headers;
  };

export type mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponse =
  | mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponseSuccess
  | mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponseError;

export const getMintCloneTokenApiTrainingRunsRunIdCloneTokenPostUrl = (
  runId: string,
) => {
  return `/api/training-runs/${runId}/clone-token`;
};

/**
 * An sft-set, grpo or serve node's trainer clone token, minted when the
 * node is about to clone and not at launch: capacity fallback, image pulls
 * and the base model download can outlast a one-hour installation token
 * (Devin, #588). The token is scoped to reading TRAINING_SFT_REPOSITORY,
 * and the App key never leaves the api. A serve node clones the commit its
 * run trained with, from the repository the serve route checked is this
 * one.
 * @summary Mint Clone Token
 */
export const mintCloneTokenApiTrainingRunsRunIdCloneTokenPost = async (
  runId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponse> => {
  return orvalFetch<mintCloneTokenApiTrainingRunsRunIdCloneTokenPostResponse>(
    getMintCloneTokenApiTrainingRunsRunIdCloneTokenPostUrl(runId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getMintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationKey =
  () => ["mintCloneTokenApiTrainingRunsRunIdCloneTokenPost"] as const;

export const getMintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof mintCloneTokenApiTrainingRunsRunIdCloneTokenPost>
      >,
      TError,
      MintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof mintCloneTokenApiTrainingRunsRunIdCloneTokenPost>
    >,
    TError,
    MintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getMintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof mintCloneTokenApiTrainingRunsRunIdCloneTokenPost>
      >,
      MintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationVariables
    > = (props) => {
      const { runId } = props ?? {};

      return mintCloneTokenApiTrainingRunsRunIdCloneTokenPost(
        runId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof mintCloneTokenApiTrainingRunsRunIdCloneTokenPost>>
  >;

export type MintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationError =
  ErrorType<HTTPValidationError>;
export type MintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationVariables =
  { runId: string };

/**
 * @summary Mint Clone Token
 */
export const useMintCloneTokenApiTrainingRunsRunIdCloneTokenPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof mintCloneTokenApiTrainingRunsRunIdCloneTokenPost>
      >,
      TError,
      MintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof mintCloneTokenApiTrainingRunsRunIdCloneTokenPost>>,
  TError,
  MintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationVariables,
  TContext
> => {
  return useMutation(
    getMintCloneTokenApiTrainingRunsRunIdCloneTokenPostMutationOptions(options),
    queryClient,
  );
};
export type getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponse200 = {
  data: void;
  status: 200;
};

export type getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponseSuccess =
  getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponse200 & {
    headers: Headers;
  };
export type getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponseError =
  getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponse422 & {
    headers: Headers;
  };

export type getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponse =
  | getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponseSuccess
  | getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponseError;

export const getGetSetFileApiTrainingRunsRunIdSetFilesFilenameGetUrl = (
  runId: string,
  filename: string,
) => {
  return `/api/training-runs/${runId}/set-files/${filename}`;
};

/**
 * One file of this run's own set, served to the node that asks with its
 * run token.
 *
 * The node holds no bucket credential for training-demonstrations/: its
 * storage identity is shared by every team's runs, so a grant there would
 * let one team's job read another's sets (Devin, #714). The api serves
 * exactly the files the set's receipt names, under the row's own team.
 * Served, not signed: a bucket read with Workload Identity cannot sign a
 * URL (TRA-1493), and this way the node needs one path on both providers.
 * @summary Get Set File
 */
export const getSetFileApiTrainingRunsRunIdSetFilesFilenameGet = async (
  runId: string,
  filename: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponse> => {
  return orvalFetch<getSetFileApiTrainingRunsRunIdSetFilesFilenameGetResponse>(
    getGetSetFileApiTrainingRunsRunIdSetFilesFilenameGetUrl(runId, filename),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSetFileApiTrainingRunsRunIdSetFilesFilenameGetQueryKey = (
  runId: string,
  filename: string,
) => {
  return [`/api/training-runs/${runId}/set-files/${filename}`] as const;
};

export const getGetSetFileApiTrainingRunsRunIdSetFilesFilenameGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    runId: string,
    filename: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSetFileApiTrainingRunsRunIdSetFilesFilenameGetQueryKey(
        runId,
        filename,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
      >
    > = ({ signal }) =>
      getSetFileApiTrainingRunsRunIdSetFilesFilenameGet(runId, filename, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled:
        runId !== null &&
        runId !== undefined &&
        filename !== null &&
        filename !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetSetFileApiTrainingRunsRunIdSetFilesFilenameGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
    >
  >;
export type GetSetFileApiTrainingRunsRunIdSetFilesFilenameGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetSetFileApiTrainingRunsRunIdSetFilesFilenameGet<
  TData = Awaited<
    ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  runId: string,
  filename: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSetFileApiTrainingRunsRunIdSetFilesFilenameGet<
  TData = Awaited<
    ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  runId: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSetFileApiTrainingRunsRunIdSetFilesFilenameGet<
  TData = Awaited<
    ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  runId: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Set File
 */

export function useGetSetFileApiTrainingRunsRunIdSetFilesFilenameGet<
  TData = Awaited<
    ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  runId: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSetFileApiTrainingRunsRunIdSetFilesFilenameGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetSetFileApiTrainingRunsRunIdSetFilesFilenameGetQueryOptions(
      runId,
      filename,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type stopTrainingRunApiTrainingRunsRunIdStopPostResponse200 = {
  data: TrainingLaunchView;
  status: 200;
};

export type stopTrainingRunApiTrainingRunsRunIdStopPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type stopTrainingRunApiTrainingRunsRunIdStopPostResponseSuccess =
  stopTrainingRunApiTrainingRunsRunIdStopPostResponse200 & {
    headers: Headers;
  };
export type stopTrainingRunApiTrainingRunsRunIdStopPostResponseError =
  stopTrainingRunApiTrainingRunsRunIdStopPostResponse422 & {
    headers: Headers;
  };

export type stopTrainingRunApiTrainingRunsRunIdStopPostResponse =
  | stopTrainingRunApiTrainingRunsRunIdStopPostResponseSuccess
  | stopTrainingRunApiTrainingRunsRunIdStopPostResponseError;

export const getStopTrainingRunApiTrainingRunsRunIdStopPostUrl = (
  runId: string,
) => {
  return `/api/training-runs/${runId}/stop`;
};

/**
 * Staff-only: stop a running run of the caller's team.
 *
 * The launcher Job is deleted and awaited first, so it has stopped
 * following or provisioning the node and released the shared ~/.sky state;
 * then, with the row locked and still running, the teardown Job cancels
 * the node's job and takes the node down (launch_training_run.teardown).
 * 409 unless the run is running; 503, with the row still running, while
 * the launcher lingers.
 * @summary Stop Training Run
 */
export const stopTrainingRunApiTrainingRunsRunIdStopPost = async (
  runId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<stopTrainingRunApiTrainingRunsRunIdStopPostResponse> => {
  return orvalFetch<stopTrainingRunApiTrainingRunsRunIdStopPostResponse>(
    getStopTrainingRunApiTrainingRunsRunIdStopPostUrl(runId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getStopTrainingRunApiTrainingRunsRunIdStopPostMutationKey = () =>
  ["stopTrainingRunApiTrainingRunsRunIdStopPost"] as const;

export const getStopTrainingRunApiTrainingRunsRunIdStopPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stopTrainingRunApiTrainingRunsRunIdStopPost>>,
    TError,
    StopTrainingRunApiTrainingRunsRunIdStopPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stopTrainingRunApiTrainingRunsRunIdStopPost>>,
  TError,
  StopTrainingRunApiTrainingRunsRunIdStopPostMutationVariables,
  TContext
> => {
  const mutationKey =
    getStopTrainingRunApiTrainingRunsRunIdStopPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stopTrainingRunApiTrainingRunsRunIdStopPost>>,
    StopTrainingRunApiTrainingRunsRunIdStopPostMutationVariables
  > = (props) => {
    const { runId } = props ?? {};

    return stopTrainingRunApiTrainingRunsRunIdStopPost(runId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StopTrainingRunApiTrainingRunsRunIdStopPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof stopTrainingRunApiTrainingRunsRunIdStopPost>>
  >;

export type StopTrainingRunApiTrainingRunsRunIdStopPostMutationError =
  ErrorType<HTTPValidationError>;
export type StopTrainingRunApiTrainingRunsRunIdStopPostMutationVariables = {
  runId: string;
};

/**
 * @summary Stop Training Run
 */
export const useStopTrainingRunApiTrainingRunsRunIdStopPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stopTrainingRunApiTrainingRunsRunIdStopPost>>,
      TError,
      StopTrainingRunApiTrainingRunsRunIdStopPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stopTrainingRunApiTrainingRunsRunIdStopPost>>,
  TError,
  StopTrainingRunApiTrainingRunsRunIdStopPostMutationVariables,
  TContext
> => {
  return useMutation(
    getStopTrainingRunApiTrainingRunsRunIdStopPostMutationOptions(options),
    queryClient,
  );
};
export type reportTrainingRunApiTrainingRunsRunIdReportPostResponse202 = {
  data: TrainingLaunchView;
  status: 202;
};

export type reportTrainingRunApiTrainingRunsRunIdReportPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type reportTrainingRunApiTrainingRunsRunIdReportPostResponseSuccess =
  reportTrainingRunApiTrainingRunsRunIdReportPostResponse202 & {
    headers: Headers;
  };
export type reportTrainingRunApiTrainingRunsRunIdReportPostResponseError =
  reportTrainingRunApiTrainingRunsRunIdReportPostResponse422 & {
    headers: Headers;
  };

export type reportTrainingRunApiTrainingRunsRunIdReportPostResponse =
  | reportTrainingRunApiTrainingRunsRunIdReportPostResponseSuccess
  | reportTrainingRunApiTrainingRunsRunIdReportPostResponseError;

export const getReportTrainingRunApiTrainingRunsRunIdReportPostUrl = (
  runId: string,
) => {
  return `/api/training-runs/${runId}/report`;
};

/**
 * A team member asks TrainLoop to look at a run that failed or stopped.
 *
 * Posts the row plus the tail of the launcher's log to #platform; the
 * launcher uploads that log to the run's own bucket prefix at exit
 * (tools/launch_training_run.py), so the api reads only the team's prefix
 * and no pod. The customer never sees the log. 409 while the run is still
 * running or completed.
 * @summary Report Training Run
 */
export const reportTrainingRunApiTrainingRunsRunIdReportPost = async (
  runId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<reportTrainingRunApiTrainingRunsRunIdReportPostResponse> => {
  return orvalFetch<reportTrainingRunApiTrainingRunsRunIdReportPostResponse>(
    getReportTrainingRunApiTrainingRunsRunIdReportPostUrl(runId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getReportTrainingRunApiTrainingRunsRunIdReportPostMutationKey =
  () => ["reportTrainingRunApiTrainingRunsRunIdReportPost"] as const;

export const getReportTrainingRunApiTrainingRunsRunIdReportPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof reportTrainingRunApiTrainingRunsRunIdReportPost>
      >,
      TError,
      ReportTrainingRunApiTrainingRunsRunIdReportPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof reportTrainingRunApiTrainingRunsRunIdReportPost>>,
    TError,
    ReportTrainingRunApiTrainingRunsRunIdReportPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getReportTrainingRunApiTrainingRunsRunIdReportPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof reportTrainingRunApiTrainingRunsRunIdReportPost>
      >,
      ReportTrainingRunApiTrainingRunsRunIdReportPostMutationVariables
    > = (props) => {
      const { runId } = props ?? {};

      return reportTrainingRunApiTrainingRunsRunIdReportPost(
        runId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReportTrainingRunApiTrainingRunsRunIdReportPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof reportTrainingRunApiTrainingRunsRunIdReportPost>>
  >;

export type ReportTrainingRunApiTrainingRunsRunIdReportPostMutationError =
  ErrorType<HTTPValidationError>;
export type ReportTrainingRunApiTrainingRunsRunIdReportPostMutationVariables = {
  runId: string;
};

/**
 * @summary Report Training Run
 */
export const useReportTrainingRunApiTrainingRunsRunIdReportPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof reportTrainingRunApiTrainingRunsRunIdReportPost>
      >,
      TError,
      ReportTrainingRunApiTrainingRunsRunIdReportPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reportTrainingRunApiTrainingRunsRunIdReportPost>>,
  TError,
  ReportTrainingRunApiTrainingRunsRunIdReportPostMutationVariables,
  TContext
> => {
  return useMutation(
    getReportTrainingRunApiTrainingRunsRunIdReportPostMutationOptions(options),
    queryClient,
  );
};
export type getTrainingScheduleApiTrainingRunsScheduleGetResponse200 = {
  data: TrainingScheduleResponse;
  status: 200;
};

export type getTrainingScheduleApiTrainingRunsScheduleGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTrainingScheduleApiTrainingRunsScheduleGetResponseSuccess =
  getTrainingScheduleApiTrainingRunsScheduleGetResponse200 & {
    headers: Headers;
  };
export type getTrainingScheduleApiTrainingRunsScheduleGetResponseError =
  getTrainingScheduleApiTrainingRunsScheduleGetResponse422 & {
    headers: Headers;
  };

export type getTrainingScheduleApiTrainingRunsScheduleGetResponse =
  | getTrainingScheduleApiTrainingRunsScheduleGetResponseSuccess
  | getTrainingScheduleApiTrainingRunsScheduleGetResponseError;

export const getGetTrainingScheduleApiTrainingRunsScheduleGetUrl = () => {
  return `/api/training-runs/schedule`;
};

/**
 * Staff-only: the selected team's scheduled run, when its timer next
 * starts one, where a run of it would start now, the last run it started,
 * and the dataset a run that pins none would train now.
 * @summary Get Training Schedule
 */
export const getTrainingScheduleApiTrainingRunsScheduleGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getTrainingScheduleApiTrainingRunsScheduleGetResponse> => {
  return orvalFetch<getTrainingScheduleApiTrainingRunsScheduleGetResponse>(
    getGetTrainingScheduleApiTrainingRunsScheduleGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTrainingScheduleApiTrainingRunsScheduleGetQueryKey = () => {
  return [`/api/training-runs/schedule`] as const;
};

export const getGetTrainingScheduleApiTrainingRunsScheduleGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTrainingScheduleApiTrainingRunsScheduleGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>>
  > = ({ signal }) =>
    getTrainingScheduleApiTrainingRunsScheduleGet({
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrainingScheduleApiTrainingRunsScheduleGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>>
  >;
export type GetTrainingScheduleApiTrainingRunsScheduleGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTrainingScheduleApiTrainingRunsScheduleGet<
  TData = Awaited<
    ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainingScheduleApiTrainingRunsScheduleGet<
  TData = Awaited<
    ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrainingScheduleApiTrainingRunsScheduleGet<
  TData = Awaited<
    ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Training Schedule
 */

export function useGetTrainingScheduleApiTrainingRunsScheduleGet<
  TData = Awaited<
    ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTrainingScheduleApiTrainingRunsScheduleGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTrainingScheduleApiTrainingRunsScheduleGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type saveTrainingScheduleApiTrainingRunsSchedulePutResponse200 = {
  data: TrainingScheduleResponse;
  status: 200;
};

export type saveTrainingScheduleApiTrainingRunsSchedulePutResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type saveTrainingScheduleApiTrainingRunsSchedulePutResponseSuccess =
  saveTrainingScheduleApiTrainingRunsSchedulePutResponse200 & {
    headers: Headers;
  };
export type saveTrainingScheduleApiTrainingRunsSchedulePutResponseError =
  saveTrainingScheduleApiTrainingRunsSchedulePutResponse422 & {
    headers: Headers;
  };

export type saveTrainingScheduleApiTrainingRunsSchedulePutResponse =
  | saveTrainingScheduleApiTrainingRunsSchedulePutResponseSuccess
  | saveTrainingScheduleApiTrainingRunsSchedulePutResponseError;

export const getSaveTrainingScheduleApiTrainingRunsSchedulePutUrl = () => {
  return `/api/training-runs/schedule`;
};

/**
 * Staff-only: create or replace the scheduled run of a team the staff
 * member belongs to (`get_member_team_id`: never a team they only view).
 *
 * An enabled schedule is saved only when a run of it would start now: the
 * launch's own checks pass on the dataset and the adapter the timer would
 * choose, and no other team's run starts on the same tick (409, which
 * does not say whose). A paused one is saved as it is, so a schedule that
 * has stopped passing can always be paused.
 * @summary Save Training Schedule
 */
export const saveTrainingScheduleApiTrainingRunsSchedulePut = async (
  trainingScheduleUpdate: TrainingScheduleUpdate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<saveTrainingScheduleApiTrainingRunsSchedulePutResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<saveTrainingScheduleApiTrainingRunsSchedulePutResponse>(
    getSaveTrainingScheduleApiTrainingRunsSchedulePutUrl(),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(trainingScheduleUpdate),
    },
  );
};

export const getSaveTrainingScheduleApiTrainingRunsSchedulePutMutationKey =
  () => ["saveTrainingScheduleApiTrainingRunsSchedulePut"] as const;

export const getSaveTrainingScheduleApiTrainingRunsSchedulePutMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof saveTrainingScheduleApiTrainingRunsSchedulePut>
      >,
      TError,
      SaveTrainingScheduleApiTrainingRunsSchedulePutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof saveTrainingScheduleApiTrainingRunsSchedulePut>>,
    TError,
    SaveTrainingScheduleApiTrainingRunsSchedulePutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getSaveTrainingScheduleApiTrainingRunsSchedulePutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof saveTrainingScheduleApiTrainingRunsSchedulePut>
      >,
      SaveTrainingScheduleApiTrainingRunsSchedulePutMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return saveTrainingScheduleApiTrainingRunsSchedulePut(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SaveTrainingScheduleApiTrainingRunsSchedulePutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof saveTrainingScheduleApiTrainingRunsSchedulePut>>
  >;
export type SaveTrainingScheduleApiTrainingRunsSchedulePutMutationBody =
  TrainingScheduleUpdate;
export type SaveTrainingScheduleApiTrainingRunsSchedulePutMutationError =
  ErrorType<HTTPValidationError>;
export type SaveTrainingScheduleApiTrainingRunsSchedulePutMutationVariables = {
  data: TrainingScheduleUpdate;
};

/**
 * @summary Save Training Schedule
 */
export const useSaveTrainingScheduleApiTrainingRunsSchedulePut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof saveTrainingScheduleApiTrainingRunsSchedulePut>
      >,
      TError,
      SaveTrainingScheduleApiTrainingRunsSchedulePutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveTrainingScheduleApiTrainingRunsSchedulePut>>,
  TError,
  SaveTrainingScheduleApiTrainingRunsSchedulePutMutationVariables,
  TContext
> => {
  return useMutation(
    getSaveTrainingScheduleApiTrainingRunsSchedulePutMutationOptions(options),
    queryClient,
  );
};
export type runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponse201 = {
  data: TrainingLaunchView;
  status: 201;
};

export type runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponseSuccess =
  runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponse201 & {
    headers: Headers;
  };
export type runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponseError =
  runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponse422 & {
    headers: Headers;
  };

export type runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponse =
  | runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponseSuccess
  | runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponseError;

export const getRunTrainingScheduleNowApiTrainingRunsScheduleRunPostUrl =
  () => {
    return `/api/training-runs/schedule/run`;
  };

/**
 * Staff-only: start a run of the team's saved schedule now, paused or
 * not. It is the run the timer would start: the same dataset and adapter
 * choice, through the same launch, with ``schedule`` as its launcher. The
 * row's clock is not touched, so the next tick still fires.
 * @summary Run Training Schedule Now
 */
export const runTrainingScheduleNowApiTrainingRunsScheduleRunPost = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponse> => {
  return orvalFetch<runTrainingScheduleNowApiTrainingRunsScheduleRunPostResponse>(
    getRunTrainingScheduleNowApiTrainingRunsScheduleRunPostUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRunTrainingScheduleNowApiTrainingRunsScheduleRunPostMutationKey =
  () => ["runTrainingScheduleNowApiTrainingRunsScheduleRunPost"] as const;

export const getRunTrainingScheduleNowApiTrainingRunsScheduleRunPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof runTrainingScheduleNowApiTrainingRunsScheduleRunPost>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof runTrainingScheduleNowApiTrainingRunsScheduleRunPost>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey =
      getRunTrainingScheduleNowApiTrainingRunsScheduleRunPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof runTrainingScheduleNowApiTrainingRunsScheduleRunPost>
      >,
      void
    > = () => {
      return runTrainingScheduleNowApiTrainingRunsScheduleRunPost(
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RunTrainingScheduleNowApiTrainingRunsScheduleRunPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof runTrainingScheduleNowApiTrainingRunsScheduleRunPost>
    >
  >;

export type RunTrainingScheduleNowApiTrainingRunsScheduleRunPostMutationError =
  ErrorType<HTTPValidationError>;

/**
 * @summary Run Training Schedule Now
 */
export const useRunTrainingScheduleNowApiTrainingRunsScheduleRunPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof runTrainingScheduleNowApiTrainingRunsScheduleRunPost>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof runTrainingScheduleNowApiTrainingRunsScheduleRunPost>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getRunTrainingScheduleNowApiTrainingRunsScheduleRunPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
